export default {"src":"/_next/static/media/trash.3b577ddf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};